module.exports = __webpack_public_path__ + "static/media/headerImgIcon.47cf47fe.svg";